import type { FlowConfig } from '@swf/core/types/Wizard';

import { CashierFlowType } from '../../../types/Cashier';

import usePaymentVerificationDepositFlow from './usePaymentVerificationDepositFlow';
import usePaymentVerificationWithdrawFlow from './usePaymentVerificationWithdrawFlow';

const usePaymentVerificationFlow = (cashierFlow: CashierFlowType): FlowConfig => {
  const depositFlow = usePaymentVerificationDepositFlow();
  const withdrawFlow = usePaymentVerificationWithdrawFlow();

  const flow = {
    [CashierFlowType.FirstDeposit]: depositFlow,
    [CashierFlowType.FirstWithdraw]: withdrawFlow
  };

  return flow[cashierFlow];
};

export default usePaymentVerificationFlow;
